// Reading documents in chat: the assistant's read_document tool (PDFs the person attached), and the page fields
// read_webpage also uses when a link is a PDF.
import { z } from "zod";

export const DocumentPagesField = z
  .string()
  .max(200)
  .optional()
  .describe(
    'Pages to read, e.g. "5", "3-7", "1,4,9-12" or "10-" (to the end). Omit to start at page 1; to go on, pass the nextPages of the previous part.',
  );

export const DocumentLookField = z
  .boolean()
  .optional()
  .describe(
    "Also see the pages as pictures (at most 4), to read a table, chart, form or layout exactly. Pages with no text (scans) are shown anyway.",
  );

export const ReadDocumentInput = z.object({
  assetId: z.string().describe("Asset id of the attached PDF."),
  pages: DocumentPagesField,
  look: DocumentLookField,
});
export type ReadDocumentInput = z.infer<typeof ReadDocumentInput>;

/** Where a part of a document sits in it, and which of its pages the assistant saw as pictures. */
export interface DocumentPages {
  pageCount: number;
  /** Pages in this part, e.g. "1-12" or "3, 7-9". */
  pages: string;
  /** Pages to ask for next, or null when this part ends what was asked for. */
  nextPages: string | null;
  /** Pages shown to the assistant as pictures after the result. */
  shownPages: number[];
}

/** One part of an attached PDF. */
export interface ReadDocumentOutput extends DocumentPages {
  assetId: string;
  /** File name as uploaded. */
  name: string | null;
  /** Title from the PDF's own information, if it has one. */
  title: string | null;
  /** Text of the pages, each under a "## Page N" heading. */
  content: string;
  /** Something the assistant should know (a page cut at the size limit, pages that cannot be seen). */
  note: string | null;
}
